import * as React from "react"


export default function pageProductTypeColumn() {
    return {
        name: 'pageProductType', label: 'Product Category',
        options:{
            setCellHeaderProps: () => ({ sx: { textAlign: 'center' } }),
            setCellProps: () => ({ sx: { textAlign: "center", fontSize: '0.875rem' } }),
        }

    }
}